import { createSlice } from '@reduxjs/toolkit';
import i18n from 'i18n/i18n';

type OutputMasterState = {
  outputReportData: any;
  total: number;
  loading: boolean;
  userGroup: any;
  sqlKnr: any;
  message: string;
  dataSearch: any;
};

const initialState: OutputMasterState = {
  outputReportData: {},
  total: 0,
  loading: false,
  userGroup: [],
  sqlKnr: [],
  dataSearch: [],
  message: '',
};

export const outputMasterSlice = createSlice({
  name: 'outputReportMaster',
  initialState,
  reducers: {
    filterOutputReport: (state, action) => {
      state.loading = true;
    },
    filterOutputReportSuccess: (state, action) => {
      if (action.payload) {
        state.outputReportData = action.payload;
        state.message = '';
      }
      if (!action.payload) {
        state.message = i18n.t('message.common.0001');
      }
      state.loading = false;
    },
    filterOutputReportFailure: (state, action) => {
      state.loading = action.payload.loading;
    },

    getUserGroup: (state, action) => {},
    getUserGroupSuccess: (state, action) => {
      state.userGroup = action.payload;
      state.sqlKnr = [];
    },

    getSqlKnr: (state, action) => {},
    getSqlKnrSuccess: (state, action) => {
      state.sqlKnr = action.payload;
    },

    getOutputDataSearch: (state, action) => {
      state.loading = true;
    },
    getOutputDataSearchSuccess: (state, action) => {
      if (action.payload.total > 0) {
        state.dataSearch = action.payload.data;
        state.total = action.payload.total;
        state.message = '';
      }
      if (action.payload.total === 0) {
        state.dataSearch = [];
        state.message = i18n.t('message.common.0001');
        state.total = 0;
      }
      state.loading = false;
    },
    getOutputDataSearchFailure: (state, action) => {
      state.loading = action.payload.loading;
    },
    cleanData: (state, action) => {
      state.userGroup = [];
      state.sqlKnr = [];
      state.outputReportData = [];
      state.dataSearch = [];
      state.total = 0;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const {
  filterOutputReport,
  filterOutputReportSuccess,
  filterOutputReportFailure,
  getOutputDataSearch,
  getOutputDataSearchSuccess,
  getOutputDataSearchFailure,
  getUserGroup,
  getUserGroupSuccess,
  getSqlKnr,
  cleanData,
  getSqlKnrSuccess,
  setLoading,
} = outputMasterSlice.actions;

export default outputMasterSlice.reducer;
